import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';

// Styled skeleton element with pulsing animation
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSkeleton = styled.div.withConfig({
  displayName: "SkeletonTimePicker__StyledSkeleton"
})(["height:20px;width:80px;margin:auto;background-color:#eaf0f6;animation:pulse 0.5s infinite alternate;"]);
const SkeletonTimePicker = () => {
  const renderTimePickerButtons = () => {
    return [...Array(4)].map((value, index) => {
      return /*#__PURE__*/_jsx(View, {
        paddingBlock: "100",
        paddingInlineEnd: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(SelectableButton, {
          block: true,
          paddingBlock: "0",
          paddingInline: "0",
          selected: false,
          children: /*#__PURE__*/_jsx(StyledSkeleton, {})
        })
      }, index);
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "90%",
    marginBlockStart: "600",
    marginInline: "400",
    paddingBlock: "100",
    paddingInline: "100",
    children: [/*#__PURE__*/_jsx(H5, {
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.timePicker.header"
      })
    }), renderTimePickerButtons()]
  });
};
export default SkeletonTimePicker;